import gql from "graphql-tag";

export const GET_CLUB_REVIEW_COUNT = gql`
  query ClubReviewCount($club_profile_id: uuid) {
    club_reviews_aggregate(
      where: { club_profile_id: { _eq: $club_profile_id } }
    ) {
      aggregate {
        count
      }
    }
  }
`;
